const Constants = {
  apiUrl: process.env.REACT_APP_ENV === 'localhost' ? 
      process.env.REACT_APP_LOCAL_API_URL : 
    process.env.REACT_APP_ENV === 'development' ?
      process.env.REACT_APP_DEV_API_URL : 
    process.env.REACT_APP_PRD_API_URL    
};

export default Constants;
